const styles = (theme) => ({
  parentContainer: {
    zIndex: 1000,
    position: 'absolute',
    top: 0,
    width: '100%',
    height: '100%',
    backgroundColor: theme.palette.greyScale[7],
    display: 'flex',
    flexFlow: 'column wrap',
    alignItems: 'center',
    padding: '8em 4em',
    [theme.breakpoints.down('md')]: { padding: '6em, 2em' },
    [theme.breakpoints.down('sm')]: { padding: '4em, 1em' },
  },
  textItem: {
    fontWeight: 300,
    margin: 16,
    [theme.breakpoints.down('md')]: { fontSize: 24 },
    [theme.breakpoints.down('sm')]: { fontSize: 16 },
  },
  paperAirplane: {
    width: '12em',
    height: '12em',
    [theme.breakpoints.down('md')]: { width: '8em', height: '8em' },
    [theme.breakpoints.down('sm')]: { width: '6em', height: '6em' },
  },
  tryAgainButton: {
    fontSize: 24,
    fontWeight: 400,
    [theme.breakpoints.down('lg')]: { fontSize: 16 },
    [theme.breakpoints.down('md')]: { fontSize: 14 },
  },
});

export default styles;
